<template>
	<div class="eia-checkbox"
		:class="classes">
		<input
			:type="type"
			:id="id"
			:disabled="disabled"
			:checked="internalValue"
			:name="name"
			ref="input"
			@click="onLabelClick">
		<label
			:for="id"
			:disabled="disabled">
		</label>
	</div>
</template>

<script>
export default {
	name: 'eia-checkbox',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		stopPropagation: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: 'checkbox',
			validator( value ) {
				return value.match( /checkbox|radio/ );
			},
		},
	},

	data() {
		return {
			internalValue: this.value,
		};
	},

	computed: {
		classes() {
			return {
				disabled: this.disabled,
				[ `eia-checkbox__${this.type}` ]: true,
			};
		},
	},

	watch: {
		value() {
			this.internalValue = this.value;
		},
	},

	methods: {
		onLabelClick( event ) {
			if( this.stopPropagation ) {
				event.stopPropagation();
			}

			this.$emit( 'input', this.$refs.input.checked, this.id );
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-checkbox {
	$transition-duration: 200ms;
	$border-width: 2px;

	&.disabled {
		cursor: not-allowed;
	}

	position: relative;
	width: 1em;
	height: 1em;
	display: inline-block;

	input {
		opacity: 0;
		width: 0;
		height: 0;

		&[disabled] {
			cursor: not-allowed;
		}
	}

	label {
		position: absolute;
		top: 0;
		bottom: 0;
		display: block;
		width: 1em;
		height: 1em;
		border: $border-width solid $color-grey-dark;
		border-radius: $radius-full;
		box-sizing: border-box;
		overflow: hidden;
		margin: 0;

		&[disabled] {
			cursor: not-allowed;
			background: $color-grey-light;
			border-color: $color-grey-medium;
		}

		&:before,
		&:after {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			content: '';
			display: inline-block;
		}

		// Box
		&:before {
			background: transparent;
		}

		// check
		&:after {
			font-family: 'eia icons';
			font-weight: 900;
			content: '';
			font-size: 0.5em;
			line-height: 1.5;
			text-align: center;
			opacity: 0;
			color: $color-main;
			background: $color-success;
			text-shadow: 0 0 1px $color-main;
		}
	}

	// Checked
	input:checked + label {
		border-color: $color-success;

		&[disabled] {
			border-color: $color-grey-medium;
		}

		&:before {
			background: $color-success;
		}

		&:after {
			opacity: 1;
		}

		&:hover:not([disabled]) {
			border-color: $color-success;
			background-color: lighten( $color-success, 10% );
		}
	}

	input:focus + label {
		&,
		&:hover {
			border-color: $color-primary;
		}

		&:hover {
			opacity: 0.8;
		}
	}

	&__checkbox {
		label:after {
			content: '\0045';
		}
	}
}
</style>
